// Compute worker client: calls as Promises.
import type { Ops, OpName, Reply } from "./protocol";

export class ComputeClient {
  private worker = new Worker(new URL("./compute.worker.ts", import.meta.url), { type: "module", name: "portfel" });
  private seq = 0;
  private pending = new Map<number, { resolve: (v: unknown) => void; reject: (e: Error) => void }>();

  constructor() {
    this.worker.onmessage = (ev: MessageEvent<Reply>) => {
      const r = ev.data, p = this.pending.get(r.id);
      if (!p) return;
      this.pending.delete(r.id);
      if (r.ok) p.resolve(r.result);
      else p.reject(new Error(r.error));
    };
    this.worker.onerror = (ev) => {
      const err = new Error(ev.message || "Błąd workera obliczeniowego");
      for (const p of this.pending.values()) p.reject(err);
      this.pending.clear();
    };
  }

  call<K extends OpName>(op: K, args: Ops[K]["args"], transfer: Transferable[] = []): Promise<Ops[K]["result"]> {
    const id = ++this.seq;
    return new Promise((resolve, reject) => {
      this.pending.set(id, { resolve: resolve as (v: unknown) => void, reject });
      this.worker.postMessage({ id, op, args }, transfer);
    });
  }
}
